import gql from 'graphql-tag'

export const PUT_RELATED_INSTRUCTORS = gql`
  mutation PutRelatedInstructors($putRelatedInstructorsInput: [PutRelatedInstructorsInput!]!) {
    putRelatedInstructors(putRelatedInstructorsInput: $putRelatedInstructorsInput) {
      Success
      StatusCode
      Timestamp
      Message
      Payload
    }
  }
`

export const DELETE_RELATED_INSTRUCTOR = gql`
  mutation DeleteRelatedInstructors($payload: [DeleteRelatedInstructorInput!]!) {
    deleteRelatedInstructors(payload: $payload) {
      Success
      StatusCode
      Timestamp
      Message
      Payload
    }
  }
`
